var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "main-content dashboard", attrs: { id: "app" } },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "dash-item col-sm-6" },
          [
            _c(
              "router-link",
              {
                attrs: { slot: "item-title", to: "/funder/clients" },
                slot: "item-title",
              },
              [
                _c("div", { staticClass: "dashbox" }, [
                  _c("div", { staticClass: "desc" }, [
                    _vm.isLoaded
                      ? _c("span", { staticClass: "amount" }, [
                          _vm._v(_vm._s(_vm.getContacts)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("dashboard.cards.clients")) + " "),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon" },
                    [_c("contact-icon", { staticClass: "card-icon" })],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "dash-item col-sm-6" },
          [
            _c(
              "router-link",
              {
                attrs: { slot: "item-title", to: "/funder/invoices" },
                slot: "item-title",
              },
              [
                _c("div", { staticClass: "dashbox" }, [
                  _c("div", { staticClass: "desc" }, [
                    _vm.isLoaded
                      ? _c("span", { staticClass: "amount" }, [
                          _vm._v(_vm._s(_vm.getInvoices)),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("span", { staticClass: "title" }, [
                      _vm._v(_vm._s(_vm.$t("dashboard.cards.invoices"))),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon" },
                    [_c("invoice-icon", { staticClass: "card-icon" })],
                    1
                  ),
                ]),
              ]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-lg-12 mt-2" }, [
          _c("div", { staticClass: "card dashboard-card" }, [
            _c("div", { staticClass: "graph-body" }, [
              _c(
                "div",
                { staticClass: "card-body col-md-12 col-lg-12 col-xl-10" },
                [
                  _c("div", { staticClass: "card-header" }, [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c("h6", [
                        _c("i", {
                          staticClass: "fa fa-line-chart text-primary",
                        }),
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$tc("dashboard.invoice_chart.title", 2)
                            ) +
                            "\n      "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "col-md-3" }, [
                      _c("h6", [
                        _c("i", {
                          staticClass: "fa fa-line-chart text-primary",
                        }),
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$tc("dashboard.credit_limit.title", 2)) +
                            "\n      "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-sm-12 col-md-6 col-lg-3" },
                      [
                        _c("base-select", {
                          attrs: {
                            options: _vm.customerOption,
                            searchable: true,
                            "show-labels": false,
                            "allow-empty": true,
                            tabindex: 8,
                            placeholder: _vm.$t("dashboard.select_client"),
                            label: "company_name",
                            "track-by": "id",
                          },
                          model: {
                            value: _vm.selectedCustomer,
                            callback: function ($$v) {
                              _vm.selectedCustomer = $$v
                            },
                            expression: "selectedCustomer",
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _vm.isLoaded
                          ? _c("bar-chart", {
                              attrs: {
                                label: "Invoices",
                                labels: _vm.labels,
                                values: _vm.invoiceGroupCount,
                                backgroundColor: _vm.bgColors,
                                borderColor: _vm.bgColors,
                                hoverBackgroundColor: _vm.bgColors,
                                hoverBorderColor: _vm.bgColors,
                                updateChart: _vm.updateChart,
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-md-6" },
                      [
                        _c("p", { staticClass: "text-center" }, [
                          _vm._v(" Total Credit Limit "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$utils.formatMoney(
                                  _vm.total_credit_limit,
                                  _vm.defaultCurrency
                                )
                              ),
                            },
                          }),
                        ]),
                        _vm._v(" "),
                        _vm.isLoaded
                          ? _c("pie-chart", {
                              attrs: {
                                labels: _vm.CreditLimitLabels,
                                values: _vm.CreditLimitData,
                                bgColors: _vm.bgCreditLimitColors,
                                hoverBgColors: _vm.hoverBgColors,
                                type: "pie",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "chart-desc col-md-12 col-lg-12 col-xl-2" },
                [
                  _c("div", { staticClass: "stats" }, [
                    _c("div", { staticClass: "description" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("dashboard.invoice_chart.pending")) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.isLoaded
                        ? _c(
                            "span",
                            {
                              staticClass: "total",
                              staticStyle: { color: "#334CFF" },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.invoiceGroupCount[0]),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("dashboard.invoice_chart.offered")) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.isLoaded
                        ? _c(
                            "span",
                            {
                              staticClass: "total",
                              staticStyle: { color: "#E333FF" },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.invoiceGroupCount[1]),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("dashboard.invoice_chart.financed")) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.isLoaded
                        ? _c(
                            "span",
                            {
                              staticClass: "total",
                              staticStyle: { color: "#33FF71" },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.invoiceGroupCount[2]),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("dashboard.invoice_chart.prepaid")) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.isLoaded
                        ? _c(
                            "span",
                            {
                              staticClass: "total",
                              staticStyle: { color: "#F9FF33" },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.invoiceGroupCount[3]),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("dashboard.invoice_chart.settlement")
                            ) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.isLoaded
                        ? _c(
                            "span",
                            {
                              staticClass: "total",
                              staticStyle: { color: "#FFB233" },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.invoiceGroupCount[4]),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("dashboard.invoice_chart.rejected")) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.isLoaded
                        ? _c(
                            "span",
                            {
                              staticClass: "total",
                              staticStyle: { color: "#FF3F33" },
                            },
                            [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.invoiceGroupCount[5]),
                                },
                              }),
                            ]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "description" }, [
                      _c("span", { staticClass: "title" }, [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("dashboard.invoice_chart.total_invoice")
                            ) +
                            " "
                        ),
                      ]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _vm.isLoaded
                        ? _c("span", { staticClass: "total" }, [
                            _c("div", {
                              domProps: {
                                innerHTML: _vm._s(_vm.totalinvoiceGroup),
                              },
                            }),
                          ])
                        : _vm._e(),
                    ]),
                  ]),
                ]
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-lg-6" }, [
          _c("div", { staticClass: "card dashboard-card" }, [
            _c("div", { staticClass: " pt-4 card-bordy" }, [
              _c("div", { staticClass: "card-header" }, [
                _c("div", { staticClass: "description" }, [
                  _c("h6", { staticClass: "title" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("dashboard.total_amount_funded")) +
                        " "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.isLoaded
                    ? _c("span", { staticClass: "total" }, [
                        _c("div", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$utils.formatMoney(
                                _vm.fundedAmount,
                                _vm.defaultCurrency
                              )
                            ),
                          },
                        }),
                      ])
                    : _vm._e(),
                ]),
              ]),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "  col-md-6" }, [
          _c("div", { staticClass: "card-bordy" }, [
            _c("div", { staticClass: "card-header" }, [
              _c("div", { staticClass: "description" }, [
                _c("h6", { staticClass: "title mb-0" }, [
                  _vm._v("Set Kibor Rate "),
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "base-input" }, [
                  _c(
                    "div",
                    {
                      staticClass: "form-group",
                      staticStyle: { display: "flex" },
                    },
                    [
                      _c(
                        "money",
                        _vm._b(
                          {
                            staticClass: "input-field mr-2",
                            model: {
                              value: _vm.formData.credit_limit,
                              callback: function ($$v) {
                                _vm.$set(_vm.formData, "credit_limit", $$v)
                              },
                              expression: "formData.credit_limit",
                            },
                          },
                          "money",
                          _vm.customerCurrency,
                          false
                        )
                      ),
                      _c(
                        "base-button",
                        {
                          staticStyle: { "margin-left": "auto" },
                          attrs: {
                            size: "large",
                            icon: "save",
                            color: "theme",
                            type: "submit",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.setKiborAmountfun()
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm.$t("general.save")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }